import { FetchInvoiceFileActions } from 'store/ducks/invoices/fetch-invoice-file';
import { call, put } from 'redux-saga/effects';
import { apiTracking, apiTecnospeed, queryBuilder, notify } from 'services';
import { requestErrorHandler } from 'utils';

interface PostData {
  Grupo: string,
  CNPJ: string,
  Arquivo: string,
  ChaveNota: string,
  Url: string,
  invoiceId: number,
}

interface InvoiceFileQuery {
  query: Pick<PostData, 'Arquivo' | 'CNPJ' | 'ChaveNota' | 'invoiceId'> | string,
  existPdf?: boolean
  onSuccess?: (_?: any)=> any
  onFailure?: (_?: any)=> any
}


export function* fetchInvoiceFileRequest(action: any) {
  try {
    const { query, onSuccess, onFailure } = action as InvoiceFileQuery;

    if (typeof query === 'object') {
      const { Arquivo, invoiceId, ...rest } = query;
       const postData = queryBuilder({
        Grupo: 'kemira',
        Arquivo,
        CNPJ: rest.CNPJ,
      });

      const queryString = queryBuilder({
        Grupo: 'kemira',
        Url: '1',
        ...rest,
      });

      const { data: response } = yield call(
        apiTecnospeed.post,
        `nfe/importa`,
        postData
      );

      if (response.includes('EXCEPTION')) {
        console.log({ uploadError: response });
        notify('error', 'UploadError: Erro ao enviar o arquivo');
        if (onFailure) onFailure(response);
        yield put(FetchInvoiceFileActions.failure(response));
        return;
      }

      const { data } = yield call(apiTecnospeed.get, `nfe/imprime?${queryString}`);

      if (data.includes('EXCEPTION')) {
        console.log({ downloadError: data });
        notify('error', 'DownloadError: Erro ao baixar o arquivo');
        if (onFailure) onFailure(data);
        yield put(FetchInvoiceFileActions.failure(data));
        return;
      }

      yield put(FetchInvoiceFileActions.success(data));

      if (onSuccess) onSuccess(data);

      yield call(apiTracking.post, `invoices/save-file`, {
        linkTecnospeed: data,
        fileName: rest.ChaveNota + '.pdf',
        invoiceId,
      });
    } else {
      const { data } = yield call(apiTracking.get, `invoice-file?urlPdf=${query}`);

      yield put(FetchInvoiceFileActions.success(data));

      if (onSuccess) onSuccess(data);
    }
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', 'DownloadError: ' + errorMessage);
    yield put(FetchInvoiceFileActions.failure(errorMessage));
  }
}
